<template>
  <div class="geographicInfo">
    <router-link to="/Home" class="home"></router-link>
    <router-link to="/Home" class="exit"></router-link>
  </div>
</template>

<script>
export default {
  name: "GeographicInfo", // 地理信息
  data() {
    // 选中项
    let select = -1;

    // 菜单
    const menu = [
      {
        key: 0,
        img: "asylum",
        text: "应急避难",
      },
      {
        key: 1,
        img: "villag",
        text: "乡村游",
      },
      {
        key: 2,
        img: "toilet",
        text: "厕所",
      },
      {
        key: 3,
        img: "hotel",
        text: "酒店",
      },
      {
        key: 4,
        img: "scenic_spot",
        text: "景区",
      },
    ];
    const handleBtmItem = (e) => {
      console.log("下部导航选中", e);
      this.select = e.key;
    };
    return { handleBtmItem, menu, select };
  },
};
</script>
<style lang="scss" scoped>
.geographicInfo {
  width: 100vw;
  height: 100vh;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;

  background-image: url("../../assets/image/test/GeographicInfo.jpg");
  .home {
    width: rpx(86);
    height: rpx(49);
    position: absolute;

    top: rpx(51);
    right: rpx(313);
  }
  .exit {
    width: rpx(86);
    height: rpx(49);
    position: absolute;

    top: rpx(51);
    right: rpx(20);
  }

  header {
    width: 100%;
    height: 10%;
  }
  .content {
    width: 100%;
    height: 90%;
    padding: 0 0.5%;
    box-sizing: border-box;
    display: flex;

    .left {
      width: 20%;
      height: 100%;
      background: #000;
      .left_top {
        width: 100%;
        height: 50%;
        background: url("../../assets/image/pic/border_light.png") no-repeat
          center center;
        background-size: 100% 100%;
      }
      .left_btm {
        width: 100%;
        height: 50%;
        background: url("../../assets/image/pic/border_light.png") no-repeat
          center center;
        background-size: 100% 100%;
      }
    }
    .center {
      width: 60%;
      height: 100%;
      padding: 0 3%;
      box-sizing: border-box;
      .center_top {
        width: 100%;
        height: 87%;
      }
      .center_btm {
        width: 100%;
        height: 13%;
        background: url("../../assets/image/pic/btm_bg.png") no-repeat center
          center;
        background-size: 100% 100%;
        display: flex;
        justify-content: space-around;
        padding: 0 10%;
        box-sizing: border-box;

        .asylum_box {
          width: rpx(120);
          height: 100%;
          cursor: pointer;
          .img {
            width: 100%;
            height: 50%;
            background: url("../../assets/image/pic/asylum.png") no-repeat
              center center;
            background-size: 110% 110%;
          }
          .btm_text {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50%;
            font: normal 18px/50% "微软雅黑";
            color: #66a3ff;
          }
          &:hover {
            .img {
              background: url("../../assets/image/pic/asylumed.png") no-repeat
                center center;
            }
            .btm_text {
              color: #f9b317;
            }
          }
        }
        .hotel_box {
          width: rpx(120);
          height: 100%;
          cursor: pointer;
          .img {
            width: 100%;
            height: 50%;
            background: url("../../assets/image/pic/hotel.png") no-repeat center
              center;
            background-size: 110% 110%;
          }
          .btm_text {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50%;
            font: normal 18px/50% "微软雅黑";
            color: #66a3ff;
          }
          &:hover {
            .img {
              background: url("../../assets/image/pic/hoteled.png") no-repeat
                center center;
            }
            .btm_text {
              color: #f9b317;
            }
          }
        }
        .villag_box {
          width: rpx(120);
          height: 100%;
          cursor: pointer;
          .img {
            width: 100%;
            height: 50%;
            background: url("../../assets/image/pic/villag.png") no-repeat
              center center;
            background-size: 110% 110%;
          }
          .btm_text {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50%;
            font: normal 18px/50% "微软雅黑";
            color: #66a3ff;
          }
          &:hover {
            .img {
              background: url("../../assets/image/pic/villaged.png") no-repeat
                center center;
            }
            .btm_text {
              color: #f9b317;
            }
          }
        }
        .toilet_box {
          width: rpx(120);
          height: 100%;
          cursor: pointer;
          .img {
            width: 100%;
            height: 50%;
            background: url("../../assets/image/pic/toilet.png") no-repeat
              center center;
            background-size: 110% 110%;
          }
          .btm_text {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50%;
            font: normal 18px/50% "微软雅黑";
            color: #66a3ff;
          }
          &:hover {
            .img {
              background: url("../../assets/image/pic/toileted.png") no-repeat
                center center;
            }
            .btm_text {
              color: #f9b317;
            }
          }
        }
        .scenic_spot_box {
          width: rpx(120);
          height: 100%;
          cursor: pointer;
          .img {
            width: 100%;
            height: 50%;
            background: url("../../assets/image/pic/scenic_spot.png") no-repeat
              center center;
            background-size: 110% 110%;
          }
          .btm_text {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50%;
            font: normal 18px/50% "微软雅黑";
            color: #66a3ff;
          }
          &:hover {
            .img {
              background: url("../../assets/image/pic/scenic_spoted.png")
                no-repeat center center;
            }
            .btm_text {
              color: #f9b317;
            }
          }
        }

        .asylum_select {
          width: rpx(120);
          height: 100%;
          cursor: pointer;
          .img {
            width: 100%;
            height: 50%;
            background: url("../../assets/image/pic/asylumed.png") no-repeat
              center center;
            background-size: 110% 110%;
          }
          .btm_text {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50%;
            font: normal 18px/50% "微软雅黑";
            color: #f9b317;
          }
          &:hover {
            .img {
              background: url("../../assets/image/pic/asylumed.png") no-repeat
                center center;
            }
            .btm_text {
              color: #f9b317;
            }
          }
        }
        .hotel_select {
          width: rpx(120);
          height: 100%;
          cursor: pointer;
          .img {
            width: 100%;
            height: 50%;
            background: url("../../assets/image/pic/hoteled.png") no-repeat
              center center;
            background-size: 110% 110%;
          }
          .btm_text {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50%;
            font: normal 18px/50% "微软雅黑";
            color: #f9b317;
          }
          &:hover {
            .img {
              background: url("../../assets/image/pic/hoteled.png") no-repeat
                center center;
            }
            .btm_text {
              color: #f9b317;
            }
          }
        }
        .villag_select {
          width: rpx(120);
          height: 100%;
          cursor: pointer;
          .img {
            width: 100%;
            height: 50%;
            background: url("../../assets/image/pic/villaged.png") no-repeat
              center center;
            background-size: 110% 110%;
          }
          .btm_text {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50%;
            font: normal 18px/50% "微软雅黑";
            color: #f9b317;
          }
          &:hover {
            .img {
              background: url("../../assets/image/pic/villaged.png") no-repeat
                center center;
            }
            .btm_text {
              color: #f9b317;
            }
          }
        }
        .toilet_select {
          width: rpx(120);
          height: 100%;
          cursor: pointer;
          .img {
            width: 100%;
            height: 50%;
            background: url("../../assets/image/pic/toileted.png") no-repeat
              center center;
            background-size: 110% 110%;
          }
          .btm_text {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50%;
            font: normal 18px/50% "微软雅黑";
            color: #f9b317;
          }
          &:hover {
            .img {
              background: url("../../assets/image/pic/toileted.png") no-repeat
                center center;
            }
            .btm_text {
              color: #f9b317;
            }
          }
        }
        .scenic_spot_select {
          width: rpx(120);
          height: 100%;
          cursor: pointer;
          .img {
            width: 100%;
            height: 50%;
            background: url("../../assets/image/pic/scenic_spoted.png")
              no-repeat center center;
            background-size: 110% 110%;
          }
          .btm_text {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50%;
            font: normal 18px/50% "微软雅黑";
            color: #f9b317;
          }
          &:hover {
            .img {
              background: url("../../assets/image/pic/scenic_spoted.png")
                no-repeat center center;
            }
            .btm_text {
              color: #f9b317;
            }
          }
        }
      }
    }
    .right {
      width: 20%;
      height: 100%;
      background: url("../../assets/image/pic/border_light.png") no-repeat
        center center;
      background-size: 100% 100%;
    }
  }
}
</style>